/* Stock/availability UI labels — kept out of HTML source (theme.strings inline). */
(function () {
  if (!window.theme) window.theme = {};
  if (!theme.strings) theme.strings = {};
  Object.assign(theme.strings, {
    lowStock: 'Niskie stany magazynowe',
    inStock: 'W magazynie',
    noStock: 'Wyprzedane',
    noVariant: 'Niedostępne',
    onlyXLeft: '[quantity] w magazynie',
    awaitingSale: 'Ten produkt nie jest jeszcze dostępny w sprzedaży.'
  });
})();
